// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f07bf1c3","732":"25201a25","977":"f4912c24"}[chunkId] + ".chunk.js";
};